// Module
var code = "<div class=\"header-page\">\n  <div class=\"back\">\n    <a ng-click=\"backPrevLocation($event)\"><i class=\"fas fa-long-arrow-alt-left \"></i></a>\n  </div>\n\n  <div class=\"center\">\n    <h1 translate>{{ 'app.public.cart.my_cart' }}</h1>\n  </div>\n</div>\n\n<section class=\"m-lg\">\n  <store-cart current-user=\"currentUser\" user-login=\"userLogin\" on-error=\"onError\" on-success=\"onSuccess\" />\n</section>\n";
// Exports
var _module_exports = code;;
var path = '/cart/index.html';
var angular = require('angular');
angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;